import _ from 'lodash'
// TODO:: This is temporary fix to convert all attributes to kebabCase
// till the API adapter is ready
export const convertToSnakeCase = obj => _.transform(obj, (acc, value, key, target) => {
    const camelKey = _.isArray(target) ? key : _.snakeCase(key)

    acc[camelKey] = _.isObject(value) ? convertToSnakeCase(value) : value
})
